import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { initialQuery } from '@supplement-bacon/sb-table-filters'
import {
  WhatsappBotSetting,
  WhatsappBotSettingKey,
} from '../models/WhatsappBotSetting'
import { WHATSAPP_BOT_SETTINGS_URL } from '../utils/urls'

const fetchWhatsappBotSettings = (
  whatsappBotSettings: WhatsappBotSettingKey[],
  venueId?: number
) =>
  SBAPI.FetchPaginated<WhatsappBotSetting[]>(WHATSAPP_BOT_SETTINGS_URL, {
    ...initialQuery,
    pagination: { current: 1, pageSize: 1000 },
    filters: { keys: whatsappBotSettings },
    search: { venueId: venueId?.toString() || null },
  })

const fetchWhatsappBotSettingById = (id: number) =>
  SBAPI.Fetch<WhatsappBotSetting>(`${WHATSAPP_BOT_SETTINGS_URL}/${id}`)

const saveWhatsappBotSetting = (whatsappBotSetting: WhatsappBotSetting) =>
  SBAPI.Post(WHATSAPP_BOT_SETTINGS_URL, whatsappBotSetting)

export {
  fetchWhatsappBotSettingById,
  fetchWhatsappBotSettings,
  saveWhatsappBotSetting,
}
